import { createContext, type PropsWithChildren, useContext } from 'react';
import { getRepubMetaFromRepub, type RepubMeta } from '@cx-web/utils';

import { type Repub } from '@cx-modules/constants';

export type RepubProviderProps = {
  repub: Repub;
};

type RepubProviderData = RepubMeta & {
  repub: Repub;
};

export const RepubContext = createContext<RepubProviderData>(undefined as any as RepubProviderData);
RepubContext.displayName = 'RepubContext';

export const RepubProvider = ({ children, repub, ...props }: PropsWithChildren<RepubProviderProps>) => {
  const value = {
    repub,
    ...getRepubMetaFromRepub(repub),
  };

  return (
    <RepubContext.Provider value={value} {...props}>
      {children}
    </RepubContext.Provider>
  );
};

export const useRepubContext = () => {
  const context = useContext(RepubContext);
  if (!context) {
    throw new Error('useRepubContext can only be used inside of RepubProvider');
  }

  return context;
};
